import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './GenericStyles.css';

const FacultyLogin = () => {
    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
        deptId: '',
        deptPassword: '',
    });
    const [departments, setDepartments] = useState([]);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('faculty');
    const navigate = useNavigate();

    // Fetch departments for dropdown
    const [loading, setLoading] = useState(false);

useEffect(() => {
  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const response = await fetch("http://121.52.154.120:3001/api/departments?page=1&limit=100");
      if (!response.ok) throw new Error("Failed to fetch departments.");
      const { data } = await response.json();
      setDepartments(Array.isArray(data) ? data : []);
    } catch (error) {
      setError("Unable to load departments. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  fetchDepartments();
}, []);

    

    const validateToken = async (token) => {
        try {
            const response = await fetch('http://121.52.154.120:3001/validateToken', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            });

            if (!response.ok) {
                throw new Error('Token validation failed. Please log in again.');
            }
        } catch (error) {
            console.error('Token validation error:', error);
            localStorage.removeItem('authToken');
            throw error;
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
    
        const isFacultyLogin = activeTab === 'faculty';
        const loginPayload = isFacultyLogin
            ? { username: credentials.username, password: credentials.password, loginType: 'faculty' }
            : { username: credentials.deptId, password: credentials.deptPassword, loginType: 'department' };
    
        try {
            const response = await fetch('http://121.52.154.120:3001/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(loginPayload),
            });
    
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Login failed.');
    
            localStorage.setItem('authToken', data.authToken);
            localStorage.setItem('refreshToken', data.refreshToken); // Save refresh token locally
            localStorage.setItem('userType', isFacultyLogin ? 'faculty' : 'department');
    
            try {
                await validateToken(data.authToken);
    
                if (isFacultyLogin) {
                    navigate(`/faculty-profile/${data.user.id}`, { state: { userData: data.user } });
                } else {
                    navigate(`/department-dashboard/${data.user.id}`, { state: { deptData: data.user } });
                }
            } catch (validationError) {
                setError(validationError.message);
            }
        } catch (error) {
            console.error('Login error:', error);
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div className="faculty-login">
            <header className="height-100">
                <h1 className="text-center fw-semibold">Login</h1>
            </header>
            <div className="container my-5">
                <div className="login-tabs">
                    <button
                        className={activeTab === 'faculty' ? 'active-tab' : ''}
                        onClick={() => setActiveTab('faculty')}
                    >
                        Faculty Login
                    </button>
                    <button
                        className={activeTab === 'department' ? 'active-tab' : ''}
                        onClick={() => setActiveTab('department')}
                    >
                        Department Login
                    </button>
                </div>

                <form onSubmit={handleLogin}>
                    {activeTab === 'faculty' && (
                        <>
                            <input
                                type="text"
                                name="username"
                                placeholder="Username"
                                value={credentials.username}
                                onChange={handleInputChange}
                                required
                            />
                            <input
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={credentials.password}
                                onChange={handleInputChange}
                                required
                            />
                        </>
                    )}

                    {activeTab === 'department' && (
                        <>
                            <select
                                name="deptId"
                                value={credentials.deptId}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select Department</option>
                                {departments.map((dept) => (
                                    <option key={dept.id} value={dept.id}>
                                        {dept.deptname}
                                    </option>
                                ))}
                            </select>
                            <input
                                type="password"
                                name="deptPassword"
                                placeholder="Password"
                                value={credentials.deptPassword}
                                onChange={handleInputChange}
                                required
                            />
                        </>
                    )}

                    <button type="submit" disabled={isLoading}>
                        {isLoading ? 'Logging in...' : 'Login'}
                    </button>
                </form>

                {error && <p className="error-message">{error}</p>}

                {activeTab === 'faculty' && (
                    <div className="password-change-link">
                        <Link to="/change-password">Change Password</Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FacultyLogin;
